import { toast as sonnerToast, Toaster } from 'sonner'

/**
 * Placement component — render once at the app root.
 * All sonner configuration lives here.
 */
export const Toast = () => (
  <Toaster
    theme="dark"
    richColors
    position="top-right"
    toastOptions={{
      style: {
        fontFamily: 'var(--font-body)',
        borderRadius: '10px',
        border: '1px solid var(--color-border)',
        background: 'var(--color-bg-card)',
      },
    }}
  />
)

/**
 * Encapsulated imperative API — the only place sonner is imported.
 * Use via useToast hook; do not call sonner directly outside this file.
 */
export const showToast = (message: string, type: 'error' | 'success') => {
  if (type === 'success') {
    sonnerToast.success(message)
  } else {
    sonnerToast.error(message)
  }
}
